import React from "react";

export default function FormattedData(props) {
  let days = [
    "Sunday",
    "Monday",
    "Thuesday",
    "Wensday",
    "Thuersday",
    "Friday",
    "Saturday",
  ];

  let day = props.data.getDay();
  let hours = props.data.getHours();
  let minutes = props.data.getMinutes();
  if (hours < 10) hours = "0" + hours;
  if (minutes < 10) minutes = "0" + minutes;

  return (
    <div className="FormattedDate">
      {days[day]} {hours}:{minutes}
    </div>
  );
}
